import React from "react";

const Disclaimer: React.FC = () => {
  return (
    <section className="mt-8 text-center max-w-[800px] mx-auto">
      <p className="text-sm opacity-50 ">
        PWC Profiles is not affiliated, associated, or in any way connected with
        the owners of the amplifier brands mentioned. All trademarks and
        copyrights belong to their respective owners. The use of these names is
        purely for descriptive and comparative purposes in the context of Kemper
        Profiles and Tonex models, which aim to replicate the sonic qualities of
        the original amplifiers.
      </p>
    </section>
  );
};
export default Disclaimer;
